import type { Currency } from "../domain/types";

export function money(value: number, currency: Currency = "BRL"): string {
  const locale =
    currency === "CLP" ? "es-CL" : currency === "USD" ? "en-US" : "pt-BR";
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(
    value,
  );
}

export function shortDate(value: string | null): string {
  if (!value) return "Ainda não sincronizado";
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(value));
}

export function dateTime(value: string | null): string {
  if (!value) return "Ainda não sincronizado";
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function platformPrefix(slug: string): string {
  const map: Record<string, string> = {
    amazon: "A",
    temu: "T",
    shein: "S",
    shopee: "P",
    outro: "X",
  };
  return map[slug] ?? "X";
}

export function nextShortCode(existing: string[], slug: string): string {
  const prefix = platformPrefix(slug);
  const highest = existing
    .filter((code) => code.startsWith(prefix))
    .map((code) => Number(code.slice(1)))
    .filter(Number.isFinite)
    .reduce((max, value) => Math.max(max, value), 0);
  return `${prefix}${String(highest + 1).padStart(3, "0")}`;
}

export function extractProductId(url: string): string {
  try {
    const parsed = new URL(url);
    const queryId =
      parsed.searchParams.get("goods_id") ?? parsed.searchParams.get("asin");
    if (queryId) return queryId;
    const amazon = parsed.pathname.match(
      /\/(?:dp|gp\/product)\/([A-Z0-9]{10})/i,
    );
    if (amazon?.[1]) return amazon[1].toUpperCase();
    const temu = parsed.pathname.match(/-g-(\d+)\.html/);
    if (temu?.[1]) return temu[1];
  } catch {
    return "";
  }
  return "";
}
